import { render, staticRenderFns } from "./AddNewCandidate.vue?vue&type=template&id=4a99134e&scoped=true"
import script from "./AddNewCandidate.vue?vue&type=script&lang=ts"
export * from "./AddNewCandidate.vue?vue&type=script&lang=ts"
import style0 from "./AddNewCandidate.vue?vue&type=style&index=0&id=4a99134e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99134e",
  null
  
)

export default component.exports